import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from "redux";
import SimpleReactValidator from 'simple-react-validator';
import { createServiceProvider, getServiceProviderListDetails, editServiceProvider } from "../../redux/actions/master"

class ServiceProviderModalClass extends Component {

	state = {
		serviceProviderDetails: {
			name: '',

		},
		isEdit: false,
	}

	componentWillMount() {
		this.validator = new SimpleReactValidator({
			element: message => <span className="error-message ">{message}</span>,
			autoForceUpdate: this,
			messages: {}
		});
	}

	componentWillReceiveProps(props) {

		let { modalDetails, isEdit } = props

		this.setState({
			serviceProviderDetails: modalDetails,
			isEdit: isEdit,
		})
	}

	handleInputs = ({ target: { value, name } }) => {

		let serviceProviderDetails = Object.assign({}, this.state.serviceProviderDetails)

		serviceProviderDetails[name] = value

		this.setState({
			serviceProviderDetails
		})


	}

	handleSubmit = () => {

		if (this.validator.allValid()) {

			let { serviceProviderDetails: { name, id = '' }, isEdit } = this.state

			let body = {
				name: name
			}

			if (!isEdit) {

				this.props.createServiceProvider(body).then(() => {

					this.props.getServiceProviderListDetails().then(() => {
						let temp = {
							name: '',
						}

						this.setState({
							isEdit: false,
							serviceProviderDetails: temp

						})
					})
				})
			} else {

				this.props.editServiceProvider(id, body).then((message) => {

					this.props.getServiceProviderListDetails().then(() => {
						let temp = {
							name: '',
						}

						this.setState({
							isEdit: false,
							serviceProviderDetails: temp

						})
					})

				})
			}
			this.props.toggle()

			this.validator.hideMessages();

		} else {
			this.setState({
				isError: true
			})
			this.validator.showMessages();

		}
	}




	render() {

		let { isError, isEdit, toggle } = this.props

		let { serviceProviderDetails } = this.state

		this.validator.purgeFields();

		let { name } = serviceProviderDetails

		return (
			<section className="side-slider h-100">
				<div className="slider-header p-4">
					<div className="d-flex align-items-center">
						<h5 className="sair-sec-title"> {isEdit ? "Edit Service Provider" : "Add Service Provider"}</h5>
						<div className="ml-auto">
							<i className="icon-close font-md px-2 cursor-pointer"
								onClick={toggle}
							></i>
						</div>
					</div>
				</div>
				<div className="slider-body p-4">
					<div className={`row no-gutters ${isError ? "was-validated" : ""}`}>
						<div className="col-md-12 form-group">
							<label>Name of the service</label>
							<input
								className={`form-control ${this.validator.message('name', name, 'required') ? 'inValid' : ''}`} id="title"
								placeholder=""
								name="name"
								value={name}
								type="text"
								onChange={this.handleInputs}


							/>
							{this.validator.message('name', name, 'required')}
						</div>

					</div>

					<hr />
					<button
						className="btn btn-primary"

						onClick={() => this.handleSubmit()}

					>{isEdit ? "Update" : "Submit"}</button>
				</div>
			</section>
		)
	}
}

const mapStateToProps = state => {

	return {}

};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		createServiceProvider,
		getServiceProviderListDetails,
		editServiceProvider
	}, dispatch)
};



export const ServiceProviderModal = connect(mapStateToProps, mapDispatchToProps)(ServiceProviderModalClass)
